import { FC, Dispatch, SetStateAction } from 'react';
import { Grid, MenuItem } from '@mui/material';
import { SMBSelect } from '../../../../components';
import { IDropdownResponse, IPartClasses } from '../../../../models';
import { useQuery } from 'react-query';
import { getPartClassChildren } from '../../../../fetch';

interface IManagePartClassDropdown {
  partClassId: string | null;
  depth: number;
  setSelectedPartClassIdFilter: Dispatch<SetStateAction<string | null>>;
  hasAppliedFilters?: boolean;
  width?: number;
  required?: boolean;
  selectedValues?: IPartClasses[];
  setSelectedValues?: Dispatch<SetStateAction<IPartClasses[] | []>>;
  setSelectionsCleared: (val: boolean) => void;
}

export const ManagePartClassDropdown: FC<IManagePartClassDropdown> = ({
  partClassId,
  depth,
  setSelectedPartClassIdFilter,
  width,
  required,
  selectedValues,
  setSelectedValues,
  setSelectionsCleared
}) => {
  const { isLoading: isLoadingDropdown, data: partClassChildren } = useQuery<
    IDropdownResponse[],
    Error
  >(['part-class-children', partClassId], async () => await getPartClassChildren(partClassId));

  const handleDropdownChange = (value: string) => {
    setSelectedValues(prevValues => {
      const newValue: IPartClasses = {
        value,
        description: partClassChildren?.find(item => item.value === value)?.description || '',
        shorthand: null
      };
      const updatedValues = [...prevValues.slice(0, depth), newValue];

      return updatedValues;
    });

    setSelectionsCleared(true);
    setSelectedPartClassIdFilter(value);
  };

  return partClassChildren?.length > 0 ? (
    <>
      <Grid item xs={12} sm={width || 4}>
        <SMBSelect
          required={required && depth === 0 ? true : false}
          onChange={e => handleDropdownChange(e.target.value)}
          handleClear={() => {
            setSelectedValues(prevValues => prevValues.slice(0, depth));
            setSelectedPartClassIdFilter(partClassId);
          }}
          variant="outlined"
          name={`selectedPartClassId-${depth ?? 0}`}
          label={depth ? `Sub Category` : `Part Class`}
          id={`selectedPartClassId-${depth ?? 0}`}
          value={selectedValues[depth]?.value || ''}
          disabled={isLoadingDropdown}
          InputLabelProps={{ shrink: !!selectedValues[depth]?.value }}
        >
          {partClassChildren?.map((partClass: IDropdownResponse, index) => (
            <MenuItem key={index} value={partClass.value}>
              {partClass.description}
            </MenuItem>
          ))}
        </SMBSelect>
      </Grid>

      {selectedValues[depth]?.value && (
        <ManagePartClassDropdown
          partClassId={selectedValues[depth].value}
          depth={depth + 1}
          setSelectedPartClassIdFilter={setSelectedPartClassIdFilter}
          width={width || 4}
          required={required}
          selectedValues={selectedValues}
          setSelectedValues={setSelectedValues}
          setSelectionsCleared={setSelectionsCleared}
        />
      )}
    </>
  ) : null;
};
